/**
 * React Query hook for the current tenant's ERP registries.
 *
 * Feeds the non-production environment banner in the claimflow chrome. The
 * list only changes when an admin edits the registry, so it is fetched once
 * per session (`staleTime: Infinity`); a failure must not retry-loop behind
 * the chrome either, hence `retry: false` — the banner simply stays hidden.
 */

import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import {
  erpRegistriesService,
  type ClaimflowErpRegistry,
} from '../api/erpRegistriesService';

/** Query key for the tenant's ERP registries. */
export const CLAIMFLOW_ERP_REGISTRIES_QUERY_KEY = [
  'claimflow',
  'erp-registries',
] as const;

export function useClaimflowErpRegistries(): UseQueryResult<
  ClaimflowErpRegistry[]
> {
  return useQuery<ClaimflowErpRegistry[]>({
    queryKey: CLAIMFLOW_ERP_REGISTRIES_QUERY_KEY,
    queryFn: () => erpRegistriesService.fetchAll(),
    staleTime: Infinity,
    retry: false,
  });
}
